import Icon from "./Icon.jsx";

export default function renderIcon(props, moreProps = {}) {
  if (!props) return null;
  if (typeof props === "string") {
    props = { name: props };
  }
  return <Icon {...moreProps} {...props} />;
}
